import React from "react";
// import oeiruty from '../media/hobspot-loader.webp';
import statu from '../media/status.gif';

const Loader = ()=>{
    return(<div style={{
        overflow:'hidden',
        position:'absolute',
        top:'50%',
        left:'50%',
        transform:'translate(-50%,-50%)'
    }}>
            <img 
        alt="loader"
        src={statu}
        style={{
            // width:'100vw',
            // heigh:'100vh',
        }}
        />
    </div>)
};

export default Loader;